module.exports = __webpack_public_path__ + "img/icon-dapp-makerdao.87c36007.png";